import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useImperativeHandle } from 'react';
import { usePointCollection } from './usePointCollection';
export * from './usePointCollection';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    pointCollection,
    setPoints
  } = usePointCollection(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setPoints(props.points), [props.points]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    pointCollection
  }), [pointCollection]);
  return null;
});